<i18n
  src="@/locales/views/organization/production/delivery_container/list_containers.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('list_processes')"
    :params="{ organization_id: organization_id }"
  />

  <template v-if="load_data_general">
    <bread-crumbs
      :labels="[
        module_name,
        `${agro_exporter_process.name} - ${agro_exporter_process?.agro_exporter?.name}`
      ]"
    />

    <h1 class="page-title">
      <i class="fa-solid fa-container-storage"></i>
      <span class="space-icon"></span>
      {{ $t("labels.title") }}
    </h1>

    <div class="mt-6 flex flex-row justify-between">
      <div class="panel-plain-label">
        <badge-default
          :label="
            containers.length + ' ' + $t('labels.total_number_containers')
          "
        />
      </div>
    </div>
    <div class="mt-8 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.week") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.container_code") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.status") }}
                  </th>
                  <!-- <th scope="col" class="table-header-cell"> -->
                  <!--   {{ $t("model.container.packing_house") }} -->
                  <!-- </th> -->
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.load_date") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.waybill") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.customer") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    <i class="fa-solid fa-paperclip"></i>
                  </th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="container in containers"
                  :key="container.id"
                >
                  <td class="table-cell">{{ container.week }}</td>
                  <td
                    class="table-cell-main link"
                    @click.prevent="goToShowContainer(container.id)"
                  >
                    {{ container.container_code }}
                  </td>
                  <td class="table-cell">
                    <container-status :status_id="container.status_id" />
                  </td>
                  <!-- <td class="table-cell"> -->
                  <!--   {{ container.packing_house?.name }} -->
                  <!-- </td> -->
                  <td class="table-cell">
                    {{ dateFormatter(container.load_date) }}
                  </td>
                  <td class="table-cell">
                    {{ container.waybill }}
                  </td>
                  <td class="table-cell">
                    {{ container.customer?.name }}
                  </td>
                  <td class="table-cell">
                    {{ container.num_attachments }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>

  <loading-message v-else />
</template>

<script>
import Requester from "@/views/organization/requesters/production/delivery_container/list_containers.js";
import ContainerStatus from "@/components/views/agro_exporter/production/shared/container/ContainerStatus.vue";
export default {
  name: "OrgProductionDeliveryContainerListContainers",
  components: { ContainerStatus },
  data() {
    return {
      agro_exporter_process: {},
      containers: [],
      load_data_general: false
    };
  },
  props: {
    organization_id: { required: true },
    agro_exporter_process_id: { required: true }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => this.loadData())
    );
  },
  methods: {
    loadData: async function () {
      await this.fetchAgroExporterProcess();
      await this.fetchContainers();
      this.load_data_general = true;
    },
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.organization_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchContainers: async function () {
      let response = await Requester.fetchContainers(
        this.organization_id,
        this.agro_exporter_process_id
      );
      this.containers = response.data;
    },
    goToShowContainer: function (container_id) {
      this.$router.push({
        name: this.routeName("show_container"),
        params: {
          organization_id: this.organization_id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: container_id
        }
      });
    }
  }
};
</script>
